import { createFileRoute } from '@tanstack/react-router';
import { S7Commissioning } from '@/screens/S7Commissioning/S7Commissioning';
import { useApiClients } from '@/app/ApiProvider';

export const Route = createFileRoute('/$orgId/commissioning')({
  component: CommissioningScreen,
});

function CommissioningScreen() {
  const clients = useApiClients();
  return <S7Commissioning clients={clients} />;
}
